import { render, staticRenderFns } from "./WorksPeek.vue?vue&type=template&id=61ff3177&"
import script from "./WorksPeek.vue?vue&type=script&lang=js&"
export * from "./WorksPeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports